// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Xes1","footer":"ModalCreateQualiphyProcedure_footer__38OWt","additionData":"ModalCreateQualiphyProcedure_additionData__3gijL"};